import Box from '@mui/material/Box';
import { CellContext, type RowData } from 'src/lib/tanstack-react-table';
import { useGetInternalUserFlag } from 'src/hooks/api/use-manage-internal-user-flag';
import { Chip, CircularProgress } from 'src/components/atoms';
import { capitalize } from '@mui/material/utils';
import { StyledLabel } from './common';

const InternalUserChip = () => {
  return <Chip label="Internal User" $color="#4CAF50" size="small" />;
};
export const FullNameInternalTagCell = <TType extends RowData, TValue>({ getValue }: CellContext<TType, TValue>) => {
  const cellValue = getValue<{
    fullName: string;
    email: string;
  }>();
  const { isInternalUser, isLoading } = useGetInternalUserFlag(cellValue?.email);
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <StyledLabel>{capitalize(cellValue?.fullName || '')}</StyledLabel> &nbsp;
      {isLoading ? <CircularProgress $color="#4CAF50" size={14} thickness={6} /> : null}
      {isInternalUser ? <InternalUserChip /> : null}
    </Box>
  );
};
